uniform sampler2D uTexture; // This is the webcam video texture
varying vec2 vUV;           // New uniform for UV coordinates
uniform float uThreshold;    // The threshold value
uniform float uDotSize;
uniform float uAspectRatio; // Aspect ratio of the canvas (width / height)

uniform vec3 uCircleColor; // New uniform for circle color
uniform vec3 uBackgroundColor; // New uniform for background color

//Threshold
// void main() {
//     vec4 color = texture2D(uTexture, vUV); // Sample the webcam texture
    
//     //Calculate the brightness of the color
//     float brightness = (color.r + color.g + color.b) / 3.0;
    
//     // Apply threshold
//     if (brightness < uThreshold) {
//         color = vec4(0.0, 0.0, 0.0, 1.0); // Set to black
//     } else {
//         color = vec4(1.0, 1.0, 1.0, 1.0); // Set to white
//     }

//     gl_FragColor = color; // Output the final color
// }


//Grayscale
// void main() {
//     vec4 color = texture2D(uTexture, vUV); // Sample the webcam texture
    
//     // Calculate the luminance of the color using weights
//     float luminance = 0.299 * color.r + 0.587 * color.g + 0.114 * color.b;

//     float brightness = (luminance * 3.00) / 3.00;

//     //Apply Threshold 
//     if (brightness < uThreshold){
//         color = vec4(0.0, 0.0, 0.0, 1.0);
//     }
//     else{
//         color = vec4(1.0, 1.0, 1.0, 1.0);
//     }

//     // Create a grayscale color
//     //vec4 grayscaleColor = vec4(luminance, luminance, luminance, 1.0); // Preserve alpha

//     gl_FragColor = color; // Output the final grayscale color
// }


//Halftone #1
// void main() {
//     vec4 color = texture2D(uTexture, vUV); // Sample the webcam texture
    
//     // Calculate the brightness of the color
//     float brightness = (color.r + color.g + color.b) / 3.0;
    
//     // Define the size of the dots
//     float scale = uDotSize;
    
//     // Adjust the UV coordinates for aspect ratio to keep circles round
//     vec2 uvScaled = vec2(vUV.x * uAspectRatio, vUV.y) * scale;

//     // Create a grid and calculate distance from the center of the current grid cell
//     vec2 grid = fract(uvScaled) - 0.5;
//     float dist = length(grid);

//     // Apply threshold
//     if (brightness < uThreshold) {
//         // Make a black circle instead of setting the whole pixel to black
//         //float circleRadius = .2 * (1.0 - brightness); // Control dot size based on brightness
//         float circleRadius = .5;

//         if (dist < circleRadius) {
//             color = vec4(uCircleColor, 1.0); // Black circle
//         } else {
//             color = vec4(uBackgroundColor, 1.0); // White background
//         }
//     } else {
//         color = vec4(uBackgroundColor,1.0); // Set to white
//     }

//     gl_FragColor = color; // Output the final color
// }

//Halftone #2
void main() {
    vec4 color = texture2D(uTexture, vUV); // Sample the webcam texture

    // Calculate the brightness of the color
    float brightness = (color.r + color.g + color.b) / 3.0;

    // Define the size of the dots and adjust for aspect ratio
    float scale = uDotSize;
    vec2 uvScaled = vec2(vUV.x * uAspectRatio, vUV.y) * scale;

    // Create a grid and calculate distance from the center of the current grid cell
    vec2 grid = fract(uvScaled) - 0.5;
    float dist = length(grid);

    // Control dot size based on brightness (darker areas get larger dots)
    float circleRadius = (1.0 - brightness) ; // Scale radius based on brightness

    if (dist < circleRadius) {
        color = vec4(uCircleColor, 1.0); // Set the dot color
    } else {
        color = vec4(uBackgroundColor, 1.0); // Set the background color
    }

    gl_FragColor = color; // Output the final color
}


//Halftone #3
// void main() {
//     vec4 color = texture2D(uTexture, vUV); // Sample the webcam texture

//     // Calculate the brightness of the color
//     float brightness = (color.r + color.g + color.b) / 3.0;

//     // Define the size of the dots and adjust for aspect ratio
//     float scale = uDotSize;
//     vec2 uvScaled = vec2(vUV.x * uAspectRatio, vUV.y) * scale;

//     // Create a grid and calculate distance from the center of the current grid cell
//     vec2 grid = fract(uvScaled) - 0.5;
//     float dist = length(grid);


//     if (brightness < uThreshold) {
//         float circleRadius = (.25) ; // Scale radius based on brightness

//         if (dist < circleRadius) {
//             color = vec4(uCircleColor, 1.0); // Set the dot color
//         } else {
//             color = vec4(uBackgroundColor, 1.0); // Set the background color
//         }
//     } else {
//         color = vec4(uBackgroundColor,1.0); // Set to white
//     }
//     gl_FragColor = color; // Output the final color
// }

//Halftone #4
// void main() {
//     vec4 color = texture2D(uTexture, vUV); // Sample the webcam texture

//     // Calculate the brightness of the color
//     float brightness = (color.r + color.g + color.b) / 3.0;

//     // Define the size of the dots and adjust for aspect ratio
//     float scale = uDotSize;
//     vec2 uvScaled = vec2(vUV.x * uAspectRatio, vUV.y) * scale;

//     // Create a grid and calculate distance from the center of the current grid cell
//     vec2 grid = fract(uvScaled) - 0.5;
//     float dist = length(grid);


//     if (brightness < uThreshold) {
//         float circleRadius = (1.0 - brightness) ; // Scale radius based on brightness

//         if (dist < circleRadius) {
//             color = vec4(uCircleColor, 1.0); // Set the dot color
//         } else {
//             color = vec4(uBackgroundColor, 1.0); // Set the background color
//         }
//     } else {
//         color = vec4(uCircleColor, 1.0) ; // Set to white
//     }
//     gl_FragColor = color; // Output the final color
// }

//Halftone #5
// void main() {
//     vec4 color = texture2D(uTexture, vUV); // Sample the webcam texture

//     // Calculate the brightness of the color
//     float brightness = (color.r + color.g + color.b) / 3.0;

//     // Define the size of the dots and adjust for aspect ratio
//     float scale = uDotSize;
//     vec2 uvScaled = vec2(vUV.x * uAspectRatio, vUV.y) * scale;

//     // Create a grid and calculate distance from the center of the current grid cell
//     vec2 grid = fract(uvScaled) - 0.5;
//     float dist = length(grid);


//     if (brightness < uThreshold) {
//         float circleRadius = (1.0 - brightness) ; // Scale radius based on brightness

//         if (dist < circleRadius) {
//             color = vec4(uCircleColor, 1.0); // Set the dot color
//         } else {
//             color = vec4(uBackgroundColor, 1.0); // Set the background color
//         }
//     } else {
//         color = vec4(uBackgroundColor, 1.0) ; // Set to white
//     }
//     gl_FragColor = color; // Output the final color
// }